import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material"

export default function Confirm({title, children, open, onClose, onConfirm}){
    
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>{title || 'Confirmation'}</DialogTitle>
        <DialogContent>
            <DialogContentText>{children}</DialogContentText>
            <DialogActions>
                <Button variant='outlined' size='small' onClick={onClose}>Annuler</Button>
                <Button variant='contained' size='small' autoFocus onClick={() => onConfirm()}>Valider</Button>
            </DialogActions>
        </DialogContent>
    </Dialog>


}